localStorage.removeItem("pormoto_token");
localStorage.removeItem("pormoto_userId");

window.location.href = "/login";
